import { mtechnavi } from '~/shared/libs/clientsdk';
import { AppSaveWorker } from '..';

export interface ExecRejectSystemManagement {
  actionName: 'execRejectSystemManagement';
  request: mtechnavi.api.company.IRejectSystemManagementRequest;
}

export const execRejectSystemManagement = async (
  worker: AppSaveWorker,
  req: mtechnavi.api.company.IRejectSystemManagementRequest
) => {
  const execMethodName =
    'mtechnavi.api.company.BusinessUnitManagementService/RejectSystemManagement';

  const result = await worker.invokeListRequest(execMethodName, {
    businessUnitManagementId: req.businessUnitManagementId,
  });
  return result;
};
